<template>
  <div class="app-container calendar-list-container">
    <div class="el-card__header">
      <div class="clearfix">
        <span style="font-size: 18px;">企业认证</span>
      </div>
    </div>
    <el-card class="box-card">
      <div v-show="!isEdit" style="padding-right:30px;padding-bottom:20px;">
        <el-form ref="form" :model="companyInfo" label-width="130px">
          <el-form-item label="企业名称">
            {{companyInfo.name}}
            <span v-if="companyInfo.state == 2" style="color:#409EFF;margin-left:15px;">[{{setstate(companyInfo.state)}}]</span>
            <span v-else style="color:#d5d6d7;margin-left:15px;">[{{setstate(companyInfo.state)}}]</span>
          </el-form-item>
          <el-form-item label="税务登记号">
            <el-input v-model="companyInfo.taxNum" disabled></el-input>
          </el-form-item>
          <el-form-item label="注册时间">
            <el-input v-model="companyInfo.createTime" disabled></el-input>
          </el-form-item>
          <el-form-item v-if="companyInfo.state>0" label="认证时间">
            <el-input v-model="companyInfo.authTime" disabled></el-input>
          </el-form-item>
          <el-form-item v-if="companyInfo.state>0" label="营业资质副本" class="form-img">
            <img :src="companyInfo.businessLicense|getBaseImgUrl" style="max-width: 178px;max-height:178px;object-fit: contain;">
          </el-form-item>

          <el-form-item v-if="companyInfo.state>0" label="认证公函" class="form-img">
            <img :src="companyInfo.licence|getBaseImgUrl" style="max-width: 178px;max-height:178px;object-fit: contain;">
          </el-form-item>
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" icon="el-icon-edit" @click="edit"
              v-if="companyInfo.state!=1">{{companyInfo.state==0?"认证":companyInfo.state==2?"重新认证":"重新认证"}}</el-button>
            </el-col>
          </el-row>

        </el-form>
      </div>
      <div v-show="isEdit" style="padding-right:30px">
        <avue-form v-model="companyInfo" :option="option" @submit="chengeadmin">
          <template slot="businessLicense">
            <el-upload class="avatar-uploader" :action="'/files/fileUpload'|getBaseApiUrl" :show-file-list="false"
              :on-success="businessLicenseUploadAfter" :before-upload="uploadBefore">
              <img v-if="companyInfo.businessLicense" :src="companyInfo.businessLicense|getBaseImgUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">支持jpg,jpeg,bmp,gif,png格式照片，大小不超过5M</div>
            </el-upload>
          </template>
          <template slot="licence">
            <el-upload class="avatar-uploader" :action="'/files/fileUpload'|getBaseApiUrl" :show-file-list="false"
              :on-success="licenceUploadAfter" :before-upload="uploadBefore">
              <img v-if="companyInfo.licence" :src="companyInfo.licence|getBaseImgUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">支持jpg,jpeg,bmp,gif,png格式照片，大小不超过5M</div>
            </el-upload>
          </template>
        </avue-form>
        <div style="text-align: center;margin-bottom: 15px;">
          <el-button slot="trigger" @click="chengeadmin" type="primary">申请认证</el-button>
          <el-button slot="trigger" @click="returnInfo" >取消</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import {
    dateY
  } from "@/util/date";
  import {
    objKeySort
  } from "@/util/ajaxsign";
  import {
    apiLink,
    getImgLink
  } from "@/config/env";
  import {
    compayAuthrz,
    getAuthInfo
  } from "@/api/admin/user";

  export default {
    data() {
      return {
        companyInfo: {
          id: "",
          name: "",
          taxNum: "",
          businessLicense: "",
          licence: "",
          createTime: "",
          authTime: ""
        },
        isEdit: false,
        option: {
          emptyBtn: false,
          submitBtn: false,
          labelWidth: 110,
          emptyText: "取消",
          column: [{
              label: "企业名称",
              prop: "name",
              span: 24
            },
            {
              label: "税务登记号",
              prop: "taxNum",
              labelWidth: 110,
              span: 24
            },
            {
              label: "认证公函",
              prop: "licence",
              span: 24,
              formsolt: true
            },
            {
              label: "营业执照",
              prop: "businessLicense",
              span: 24,
              formsolt: true
            }
          ]
        }
      };
    },
    filters: {
      dataFormat: function(dateStr) {
        return dateY(dateStr);
      },
      getBaseApiUrl: function(uri) {
        if (uri) {
          return apiLink(uri);
        } else {
          return "";
        }
      },
      getBaseImgUrl: function(uri) {
        if (uri) {
          return getImgLink(uri);
        } else {
          return "";
        }
      }
    },
    created() {
      this.getcompany();
    },
    methods: {
      //获取企业信息
      getcompany() {
        getAuthInfo(objKeySort()).then(res => {
          if (res.data.code == 200) {
            this.companyInfo = res.data.data;
            this.companyInfo.createTime = dateY(this.companyInfo.createTime);
            this.companyInfo.authTime = dateY(this.companyInfo.authTime);
            this.$store.commit('SET_COMPANYSTATE', this.companyInfo.state);
          } else {
            this.$message({
              message: "获取企业信息失败",
              type: "error"
            });
          }
        });
      },

      edit() {
        this.isEdit = true;
      },

      uploadBefore(file) {
        let isImg = false;
        if (
          file.type == "image/png" ||
          file.type == "image/jpeg" ||
          file.type == "image/bmp" ||
          file.type == "image/jpg" ||
          file.type == "image/gif"
        ) {
          isImg = true;
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isImg) {
          this.$message.error("上传图片只能是jpg,jpeg,bmp,gif,png格式照片!");
        }
        if (!isLt5M) {
          this.$message.error("上传图片大小不能超过 5MB!");
        }
        return isImg && isLt5M;
      },
      //上传后的方法
      businessLicenseUploadAfter(res) {
        this.companyInfo.businessLicense = res.data.filePath;
      },
      licenceUploadAfter(res) {
        this.companyInfo.licence = res.data.filePath;
      },
      returnInfo() {
        this.isEdit = false;
      },
      chengeadmin() {
        var companydata = {
          companyName: this.companyInfo.name,
          taxNum: this.companyInfo.taxNum,
          businessLicense: this.companyInfo.businessLicense,
          licence: this.companyInfo.licence
        };
        if (companydata.taxNum.length != 15 && companydata.taxNum.length != 18 && companydata.taxNum.length != 17 &&
          companydata.taxNum.length != 20) {
          this.$message({
            message: "税务登记号只能是15/17/18/20位",
            type: "warning"
          });
          return;
        } else {
          compayAuthrz(objKeySort(companydata)).then(res => {
            if (res.data.code == 200) {
              let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
              userInfo.company = res.data.data;
              window.sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
              this.getcompany();
              this.$message({
                type: 'success',
                message: '提交申请成功!'
              })
              this.isEdit = false;
            }
          });
        }
      },
      //设置企业状态
      setstate(data) {
        //：0，未认证，1，审核中，2审核通过，3拒绝
        if (data == 3) {
          return "已拒绝";
        } else if (data == 2) {
          return "已认证";
        } else if (data == 1) {
          return "审核中";
        } else if (data >= 4) {
          return "已冻结";
        } 
        else {
          return "未认证";
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .formwidth {
    width: 38%;
  }

  .cardtop {
    margin-bottom: 20px;
  }

  .btn {
    margin-left: 150px;
    margin-bottom: 10px;
  }

  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader /deep/ .el-upload:hover {
    border-color: #409eff;

  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: contain;
  }

  .calendar-list-container {
    .el-card__header {
      border-bottom: none;
      border-top: 1px solid #EBEEF5;
      border-left: 1px solid #EBEEF5;
      border-right: 1px solid #EBEEF5;
    }
  }

  .box-card /deep/ .form-img {
    .el-form-item__content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 178px;
      height: 178px;
      background: #F5F7FA;
    }
  }

  // .avatar-uploader /deep/ .el-upload--text {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   width: 178px;
  //   height: 178px;
  // }
</style>
